import { makeRequest } from './https';
import { LoginRequest, RegisterRequest, ForgotPasswordRequest, ResetPasswordRequest, SignupWithOrganizationRequest } from '../types/auth.type';

export const login = (data: LoginRequest) => {
  return makeRequest({
    url: '/user/login',
    method: 'post',
    data,
  });
};

export const register = (data: RegisterRequest) => {
  return makeRequest({
    url: '/user/register',
    method: 'post',
    data,
  });
};

export const signupWithOrganization = (data: SignupWithOrganizationRequest) => {
  return makeRequest({
    url: '/user/signup-with-organization',
    method: 'post',
    data,
  });
};

export const refreshTokenService = (refreshToken: string) => {
  return makeRequest({
    url: '/user/refresh-token',
    method: 'post',
    data: { refresh_token: refreshToken },
    isAuthRequest: true,
  });
};

export const forgotPassword = (data: ForgotPasswordRequest) => {
  return makeRequest({
    url: '/user/forgot-password',
    method: 'post',
    data,
  });
};

export const resetPassword = (data: ResetPasswordRequest) => {
  return makeRequest({
    url: '/user/reset-password',
    method: 'post',
    data,
  });
};

export const sendOTP = (phone: string) => {
  return makeRequest({
    url: '/user/send-otp',
    method: 'post',
    data: { phone },
  });
};

export const verifyOTP = (phone: string, otp_code: string) => {
  return makeRequest({
    url: '/user/verify-otp',
    method: 'post',
    data: { phone, otp_code },
  });
}; 